var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"submit"}},[_c('AppIcon',{staticClass:"editable-submit-icon",attrs:{"name":"editable/submit","width":"24","original":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }